import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="section">
      <div className="container" style={{ textAlign: 'center' }}>
        <span className="eyebrow">404</span>
        <h1
          className="display"
          style={{
            fontSize: 'var(--text-4xl)',
            marginTop: 'var(--space-3)',
            marginBottom: 'var(--space-3)',
          }}
        >
          Page not found.
        </h1>
        <p
          style={{
            color: 'var(--color-text-secondary)',
            fontSize: 'var(--text-lg)',
            marginBottom: 'var(--space-6)',
          }}
        >
          The page you’re looking for has moved or doesn’t exist.
        </p>
        <Link to="/" className="btn btn--primary">
          Back to home
        </Link>
      </div>
    </section>
  );
}
